<template>
  <footer class="inert-while-dialog-open">
    <ul class="meta" aria-label="Weitere Informationen">
      <li>
        <a href="https://www.rewe.de/service/impressum/" target="_blank" title="Öffnen des Impressums"
          >Impressum</a
        >
      </li>
      <li>
        <a href="https://www.rewe.de/service/datenschutz/" target="_blank" title="Öffnen der Datenschutzhinweise"
          >Datenschutzhinweise</a
        >
      </li>
      <li>
        <a href="#uc-corner-modal-show" target="_top" title="Öffnen der Privatsphäre-Einstellungen">Privatsphäre-Einstellungen</a>
      </li>
    </ul>

    <ul class="social" aria-label="Social Media">
      <li>
        <a
          href="https://www.facebook.com/Rewe/"
          target="_blank"
          title="Öffnen von Facebook"
          ><i class="icon-facebook-square" aria-hidden="true"></i
        ><span>Facebook</span></a>
      </li>
      <li>
        <a
          href="https://www.youtube.com/user/REWEDeutschland"
          target="_blank"
          title="Öffnen von YouTube"
          ><i class="icon-youtube-square" aria-hidden="true"></i
        ><span>YouTube</span></a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/rewe/"
          target="_blank"
          title="Öffnen von Instagram"
          ><i class="icon-instagram" aria-hidden="true"></i
          ><span>Instagram</span></a>
      </li>
      <li>
        <a
          href="https://www.pinterest.de/rewe/"
          target="_blank"
          title="Öffnen von Pinterest"
          ><i class="icon-pinterest-square" aria-hidden="true"></i
          ><span>Pinterest</span></a>
      </li>
    </ul>

    <div class="rewe-link">
      Weiter zu
      <a href="https://www.rewe.de/?icid=feuerwerk2025_rewe-de:feuerwerk:footer_int_content_rewe-de:startseite_nn_nn_nn_nn" target="_blank" title="Öffnen von rewe.de">rewe.de ></a>
    </div>

    <ul role="doc-endnotes" class="legal-notes" v-if="!preview && !noLegal" aria-label="Rechtliche Hinweise">
      <h2 id="footnote-label" class="visually-hidden">Fußnoten</h2>
      <li role="doc-endnote" id="fn1">
        {{ $l('footerLegal') }} <sup>3</sup>
        &nbsp;<a href="#fn1-link" aria-label="zurück zur Referenz #1">↩</a>
      </li>
    </ul>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "footer-component",
  props: {
    border: {
      type: Boolean,
      required: false,
      default: true
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    },
    noLegal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState([
      "dialogOpen"
    ]),
  }
};
</script>

<style lang="scss">
@import "../scss/settings";
footer {
  box-sizing: border-box;

  width: 100%;
  padding: 25px 40px 30px 40px;
  margin-top: 0 !important;

  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: $dark-bg;

  @include mobile {
    padding: 40px 15px 30px !important;
  }
  ul.meta {
    flex: 0 0 auto;
    display: inline-block;
    width: auto;
    margin-bottom: 25px;

    li {
      display: inline-block;
      border-right: solid 1px #ffffff;
      padding: 2px 6px;
      line-height: 1;
      @include mobile {
        border-right: none;
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }
      a {
        font-weight: bold;
        text-decoration: none;
        @include focus-text-link;
      }
      &:last-child {
        border-right: none;
      }
    }
  }
  ul.social {
    flex: 0 0 auto;
    display: inline-block;
    width: auto;
    margin-bottom: 25px;
    a {
      @include focus-text-link;
      span {
        display: none;
      }
    }
    li {
      display: inline-block;
      line-height: 1;
      margin: 0 5px;
      font-size: px-to-rem(30);
    }
  }
  .rewe-link {
    display: block;
    margin: 0 0 26px 0;
    a {
      @include fontMedium;
      @include focus-text-link;
    }
    
  }

  .legal-notes {
    width: 700px;
    max-width: 100%;
    opacity: 1;
    li {
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      font-size: px-to-rem(14);
      @include fontMedium;
      line-height: px-to-rem(18);
      display: block;
      margin: 0 0 14px 0;
      a {
        display: inline !important;
        @include focus-text-link;
      }
    }
  }
}
</style>
